// extracted by mini-css-extract-plugin
export default {"tableSummary":"TableSummary_tableSummary__a6N2W","tableSummary__text":"TableSummary_tableSummary__text__QPYRK"};